import React, { useState } from "react";
import AmplitudeIcon from "../../../../assets/images/icons/button-icon.svg";
import MusicLoader from "../../DataAnalyst/sections/components/MusicLoader";

function ChatInput({
  title,
  inputPlaceholder,
  onSend,
  isDisabled,
  isCatalog,
  creditsExhausted = false,
  onUpgradeClick,
  onGetCreditsClick,
}) {
  const [input, setInput] = useState("");
  const inputLocked = isDisabled || creditsExhausted;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputLocked || !input.trim()) return;
    onSend(input);
    setInput("");
  };

  return (
    <div
      className={`w-full bg-gradient-to-r from-theme_clr1 to-theme_clr2 rounded-2xl p-4 md:p-6`}
    >
      <div className="text-white text-lg md:text-xl font-semibold mb-3 md:mb-4">
        {title}
      </div>

      {creditsExhausted && (
        <div className="mb-4 rounded-xl bg-white/10 border border-white/25 px-4 py-3 text-white text-sm">
          <p className="font-medium mb-3">
            You&apos;ve used your free credits. Upgrade to continue using Amplitude AI.
          </p>
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={onUpgradeClick}
              className="bg-[#F5BA23] hover:bg-[#e5a000] text-white text-xs font-bold uppercase rounded-full px-4 py-2 transition-colors"
            >
              Go Pro
            </button>
            {onGetCreditsClick && (
              <button
                type="button"
                onClick={onGetCreditsClick}
                className="border border-white/80 hover:bg-white/10 text-white text-xs font-semibold rounded-full px-4 py-2 transition-colors"
              >
                Get Credits
              </button>
            )}
          </div>
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className={`flex flex-col ${
          !isCatalog ? "md:flex-row md:items-center" : "md:flex-col md:items-start"
        } gap-3 md:gap-4`}
      >
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder={creditsExhausted ? "Upgrade or get credits to continue" : inputPlaceholder}
          disabled={inputLocked}
          className={`flex-1 bg-transparent border border-white rounded-full px-4 py-2 md:px-6 md:py-3 text-white placeholder-white text-base md:text-lg focus:outline-none ${
            inputLocked ? "opacity-50 cursor-not-allowed" : ""
          }`}
        />
        <button
          type="submit"
          disabled={inputLocked}
          className={`w-full md:w-auto flex items-center justify-center bg-gradient-to-t from-[#00067e] to-[#3B3B98] hover:from-[#fa6138] hover:to-[#23235b] text-white font-medium text-base md:text-lg px-6 md:px-10 py-2 md:py-3 rounded-full transition-all duration-200 shadow-md ${
            isCatalog ? "ml-auto md:ml-0" : ""
          }`}
        >
          {isDisabled ? (
            <div className="w-6 h-6 flex items-center justify-center">
              <div className="transform scale-[0.4]">
                <MusicLoader />
              </div>
            </div>
          ) : (
            <>
              <span className="md:inline">Submit</span>
              <span className="inline md:ml-3">
                <img src={AmplitudeIcon} alt="Content Creator" className="inline-block w-4 h-4 md:w-5 md:h-5 ml-3 md:ml-3" />
              </span>
            </>
          )}
        </button>
      </form>
    </div>
  );
}

export default ChatInput;
